import { render, staticRenderFns } from "./ProgettoRiabilitativoIndividualeEditComponent.vue?vue&type=template&id=0b110ed0&scoped=true"
import script from "./ProgettoRiabilitativoIndividualeEditComponent.vue?vue&type=script&lang=js"
export * from "./ProgettoRiabilitativoIndividualeEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b110ed0",
  null
  
)

export default component.exports